import {
  getNameDescriptionTableColumn,
  getCopyWithContentTableColumn,
} from '@/utils/common/tableColumn'
import { numerify } from '@/filters'
import i18n from '@/locales'

export default {
  data () {
    return {
      billProps: {
        list: this.$list.createList(this, {
          resource: 'billing_bills',
          getParams: {
            invoiceable: true,
          },
        }),
        columns: [
          getCopyWithContentTableColumn({
            field: 'id',
            title: i18n.t('scope.text_438'),
          }),
          getNameDescriptionTableColumn({
            field: 'title',
            title: i18n.t('scope.text_439'),
            edit: false,
            onManager: this.onManager,
            hideField: true,
            slotCallback: row => {
              return (
                <side-page-trigger onTrigger={() => this.handleBillOpenSidepage(row)}>{ row.title }</side-page-trigger>
              )
            },
          }),
          {
            field: 'count',
            title: i18n.t('scope.text_440'),
            minWidth: 80,
          },
          {
            field: 'origin_amount',
            title: i18n.t('scope.text_441'),
            minWidth: 80,
            formatter: ({ cellValue }) => {
              return numerify(cellValue, '0,0.00')
            },
          },
          {
            field: 'amount',
            title: i18n.t('scope.text_298'),
            minWidth: 80,
            formatter: ({ cellValue }) => {
              return numerify(cellValue, '0,0.00')
            },
          },
          {
            field: 'currency',
            title: i18n.t('scope.text_442'),
            minWidth: 80,
          },
        ],
      },
    }
  },
}
